import { type NuxtAxiosInstance } from "@nuxtjs/axios";

import { CreatorShopPostSearchParams, CreatorShopPostSearchResponse } from "@/store/creator-shop-posts/types";
import { useApi } from "@/utils/api";

import { version } from "../../../package.json";

const DEFAULT_POST_LIMIT = 36;
const DEFAULT_ANALYTICS = [`version:${version}`, "platform:web"];

export default function useCreatorShopApi($axios: NuxtAxiosInstance) {
  const url = "/v2/search";
  const api = useApi({ name: "searchService", url, $axios });

  // https://rewardstyle.atlassian.net/wiki/spaces/CP/pages/2911830413/ltk-search-service+API+Docs#Global-(Multi-Index)-Search
  // Note, the endpoint supports displayName, but it's preferred to use profileId as users can update their displayName.
  // Alogila than has to update indices which takes time, and can result in lost search results during indexing.
  async function get({
    query,
    ranking,
    profileId,
    page,
    limit = DEFAULT_POST_LIMIT,
    analytics = DEFAULT_ANALYTICS,
    filters = [],
  }: CreatorShopPostSearchParams) {
    return await api.request<CreatorShopPostSearchResponse>({
      url: `${url}/shop`,
      method: "POST",
      responseType: "json",
      data: {
        query,
        ranking,
        profileId,
        page,
        limit,
        analytics,
        filters,
      },
    });
  }

  return { get };
}
